// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.project-type-badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  line-height: 1.4;
}

.project-type-badge.type-web {
  background-color: #e3f2fd;
  color: #0d6efd;
}

.project-type-badge.type-mobile {
  background-color: #fff3cd;
  color: #fd7e14;
}

.project-type-badge.type-desktop {
  background-color: #f8d7da;
  color: #dc3545;
}

.project-type-badge.type-embedded {
  background-color: #e0f7fa;
  color: #00acc1;
}

.project-type-badge.type-api-backend {
  background-color: #e6f4ea;
  color: #28a745;
}

.project-type-badge.type-cloud-devops {
  background-color: #f3e5f5;
  color: #8e24aa;
}

.project-type-badge.type-iot {
  background-color: #e8eaf6;
  color: #3949ab;
}

.project-type-badge.type-none {
  background-color: #f1f3f5;
  color: #6c757d;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/ProjectTypeBadge.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB","sourcesContent":[".project-type-badge {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 500;\n  white-space: nowrap;\n  line-height: 1.4;\n}\n\n.project-type-badge.type-web {\n  background-color: #e3f2fd;\n  color: #0d6efd;\n}\n\n.project-type-badge.type-mobile {\n  background-color: #fff3cd;\n  color: #fd7e14;\n}\n\n.project-type-badge.type-desktop {\n  background-color: #f8d7da;\n  color: #dc3545;\n}\n\n.project-type-badge.type-embedded {\n  background-color: #e0f7fa;\n  color: #00acc1;\n}\n\n.project-type-badge.type-api-backend {\n  background-color: #e6f4ea;\n  color: #28a745;\n}\n\n.project-type-badge.type-cloud-devops {\n  background-color: #f3e5f5;\n  color: #8e24aa;\n}\n\n.project-type-badge.type-iot {\n  background-color: #e8eaf6;\n  color: #3949ab;\n}\n\n.project-type-badge.type-none {\n  background-color: #f1f3f5;\n  color: #6c757d;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
